import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { ArrowLeft, ArrowRight } from "lucide-react";

export default function TenantLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const u = await login(email, password, remember);
      nav(u.role === "tenant" ? "/tenant" : "/dashboard");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white border border-slate-200 p-8 shadow-sm rounded-sm">
        <Link to="/" className="inline-flex items-center gap-2 text-slate-500 hover:text-slate-900 text-sm mb-6 transition-colors" data-testid="tenant-back-home">
          <ArrowLeft className="w-4 h-4" /> Back
        </Link>
        <div className="overline text-slate-500 mb-2">Tenant Portal</div>
        <h1 className="text-3xl font-bold tracking-tight text-slate-900" style={{fontFamily:"Outfit"}}>Sign in to pay rent.</h1>
        <p className="mt-2 text-sm text-slate-500">Use the credentials your property manager provided.</p>
        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div>
            <label className="overline text-slate-600">Email</label>
            <input type="email" data-testid="tenant-login-email" className="w-full mt-2 input-clean" value={email} onChange={(e)=>setEmail(e.target.value)} required />
          </div>
          <div>
            <div className="flex items-center justify-between">
              <label className="overline text-slate-600">Password</label>
              <Link to="/forgot-password" className="text-xs text-slate-500 hover:text-slate-900 hover:underline" data-testid="tenant-login-forgot-password">
                Forgot password?
              </Link>
            </div>
            <input type="password" data-testid="tenant-login-password" className="w-full mt-2 input-clean" value={password} onChange={(e)=>setPassword(e.target.value)} required />
          </div>
          {err && <div className="text-sm text-red-600" data-testid="tenant-login-error">{err}</div>}
          <label className="flex items-center gap-2 text-sm text-slate-600 cursor-pointer select-none" data-testid="tenant-login-remember-label">
            <input
              type="checkbox"
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
              className="w-4 h-4 rounded-sm border-slate-300 text-slate-900 focus:ring-slate-900 cursor-pointer"
              data-testid="tenant-login-remember-checkbox"
            />
            Keep me signed in for 30 days
          </label>
          <button
            type="submit"
            disabled={busy}
            data-testid="tenant-login-submit"
            className="w-full btn-primary-dark flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {busy ? "Signing in…" : (<>Sign in <ArrowRight className="w-4 h-4" /></>)}
          </button>
        </form>
      </div>
    </div>
  );
}
